enum COMPSET_TYPE {
    MEDIAN = 'median',
    LOW = 'low',
    HIGH = 'high',
}

export default COMPSET_TYPE;
